// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import GetSafetyAnchorPointsBySiHaDocumentationRequestModel from '../../model/get-safety-anchor-points-by-si-ha-documentation-request-model';
import GetSafetyAnchorPointsBySiHaDocumentationRequestDTO from '../dto/get-safety-anchor-points-by-si-ha-documentation-request-dto';
import dtoSchema from '../schemas/get-safety-anchor-points-by-si-ha-documentation-request-schema';

export default abstract class GetSafetyAnchorPointsBySiHaDocumentationRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<GetSafetyAnchorPointsBySiHaDocumentationRequestDTO>) {
    super();
    if (data) {
      this.id = data.id;
    }
  }
  /**
  * @type {int64}
  */
  id?: number;

  static toModel(dto: DeepPartial<GetSafetyAnchorPointsBySiHaDocumentationRequestDTO>): GetSafetyAnchorPointsBySiHaDocumentationRequestModel;
  static toModel(dto: DeepPartial<GetSafetyAnchorPointsBySiHaDocumentationRequestDTO> | undefined | null): GetSafetyAnchorPointsBySiHaDocumentationRequestModel | undefined;
  static toModel(dto: DeepPartial<GetSafetyAnchorPointsBySiHaDocumentationRequestDTO> | undefined | null): GetSafetyAnchorPointsBySiHaDocumentationRequestModel | undefined {
    return dto ? new GetSafetyAnchorPointsBySiHaDocumentationRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<GetSafetyAnchorPointsBySiHaDocumentationRequestModel> | GetSafetyAnchorPointsBySiHaDocumentationRequestModel): GetSafetyAnchorPointsBySiHaDocumentationRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      id: unwrapped.id,
    } as GetSafetyAnchorPointsBySiHaDocumentationRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for GetSafetyAnchorPointsBySiHaDocumentationRequestModel, can not map to GetSafetyAnchorPointsBySiHaDocumentationRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
